module.exports = __webpack_public_path__ + "messiah-8-@2x.21324e14.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/cutouts/messiah-8-@2x.svg
 ** module id = 413
 ** module chunks = 0
 **/